import React from "react";

const Youtube = ({ color, height, width }) => (
  <svg width={width} height={height} viewBox="0 0 40 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_10_46)">
      <path
        d="M39.1669 4.37253C38.706 2.65052 37.3526 1.29727 35.6306 0.836312C32.5091 0 20 0 20 0C20 0 7.49094 0 4.37274 0.836312C2.65064 1.29727 1.29733 2.65052 0.836352 4.37253C0 7.49059 0 14 0 14C0 14 0 20.5094 0.836352 23.6275C1.29733 25.3495 2.65064 26.7027 4.37274 27.1637C7.49094 28 20 28 20 28C20 28 32.5091 28 35.6273 27.1637C37.3494 26.7027 38.7027 25.3495 39.1636 23.6275C40 20.5094 40 14 40 14C40 14 40 7.49059 39.1636 4.37253H39.1669ZM15.9993 19.9991V8.00094L26.3912 14L15.9993 19.9991Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_10_46">
        <rect width="40" height="28" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

Youtube.defaultProps = {
  width: 28,
  height: 28,
  color: "white"
};
export default Youtube;
